import React, { useState } from 'react'
import lock from '../assets/icons/lock.svg'
import linked from '../assets/icons/linked-acccount.svg'
import lifetime from '../assets/icons/session-time.svg'
import media from '../assets/icons/social-media.svg'
import usericon from '../assets/icons/user.svg'
import logout from '../apis/logout'
import { useAuth } from '../hooks/AuthContext'
import { motion, AnimatePresence } from 'framer-motion'
import AdminInfo from '../components/settings/AdminInfo'
import Security from '../components/settings/Security'
import SocialMedia from '../components/settings/SocialMedia'
import LinkedAccounts from '../components/settings/LinkedAccounts'
import SessionLifeTime from '../components/settings/SessionLifeTime'

const Settings = () => {
  const [activeTab, setActiveTab] = useState(null)
  const { logout: authLogout } = useAuth()
  const [loading, setLoading] = useState(false)

  const handelLogout = async () => {
    setLoading(true)
    try {
      await logout()
      authLogout()
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  const toggleTab = (tabName) => {
    setActiveTab((prevTab) => (prevTab === tabName ? null : tabName))
  }

  return (
    <div className="w-full p-4">
      <div className="text-2xl text-blueButton mb-6">Settings</div>
      <div className="h-full shadow rounded-xl pb-2 px-8 flex flex-col gap-4">
        {/* Admin Information Tab */}
        <div className="border-b-[1px] border-gray/50 pb-2">
          <div
            onClick={() => toggleTab('adminInfo')}
            className="flex justify-between items-center cursor-pointer"
          >
            <div className="text-xl text-darkBlue flex gap-4 p-3">
              <img src={usericon} alt="" className=" w-8 h-8" />
              Admin Information
            </div>
            <span>{activeTab === 'adminInfo' ? '-' : '+'}</span>
          </div>
          <AnimatePresence>
            {activeTab === 'adminInfo' && (
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
                className="mt-2 pl-4 text-gray-600"
              >
                <AdminInfo />
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        {/* Security Tab */}
        <div className="border-b-[1px] border-gray/50 pb-2">
          <div
            onClick={() => toggleTab('security')}
            className="flex justify-between items-center cursor-pointer"
          >
            <div className="text-xl text-darkBlue flex gap-4 p-3">
              <img src={lock} alt="" className=" w-8 h-8" />
              Security
            </div>
            <span>{activeTab === 'security' ? '-' : '+'}</span>
          </div>
          <AnimatePresence>
            {activeTab === 'security' && (
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
                className="mt-2 pl-4 text-gray-600"
              >
                <Security />
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        {/* Social Media Tab */}
        <div className="border-b-[1px] border-gray/50 pb-2">
          <div
            onClick={() => toggleTab('socialMedia')}
            className="flex justify-between items-center cursor-pointer"
          >
            <div className="text-xl text-darkBlue flex gap-4 p-3">
              <img src={media} alt="" className=" w-8 h-8" />
              Socila Media
            </div>
            <span>{activeTab === 'socialMedia' ? '-' : '+'}</span>
          </div>
          <AnimatePresence>
            {activeTab === 'socialMedia' && (
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
                className="mt-2"
              >
                <SocialMedia />
              </motion.div>
            )}
          </AnimatePresence>
        </div>
        {/* Social Media Tab */}
        <div className="border-b-[1px] border-gray/50 pb-2">
          <div
            onClick={() => toggleTab('sessionlifetime')}
            className="flex justify-between items-center cursor-pointer"
          >
            <div className="text-xl text-darkBlue flex gap-4 p-3">
              <img src={lifetime} alt="" className=" w-8 h-8" />
              Session Life Time
            </div>
            <span>{activeTab === 'sessionlifetime' ? '-' : '+'}</span>
          </div>
          <AnimatePresence>
            {activeTab === 'sessionlifetime' && (
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
                className="mt-2 pl-4 text-gray-600"
              >
                <SessionLifeTime />
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        {/* Linked Accounts Tab */}
        <div className="pb-2">
          <div
            onClick={() => toggleTab('linkedAccounts')}
            className="flex justify-between items-center cursor-pointer"
          >
            <div className="text-xl text-darkBlue flex gap-4 p-3">
              <img src={linked} alt="" className=" w-8 h-8" />
              Linked Acoounts
            </div>
            <span>{activeTab === 'linkedAccounts' ? '-' : '+'}</span>
          </div>
          <AnimatePresence>
            {activeTab === 'linkedAccounts' && (
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
                className="mt-2 pl-4 text-gray-600"
              >
                <LinkedAccounts />
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        {/* Logout Button */}
        <div className="pt-4">
          <button
            disabled={loading}
            onClick={handelLogout}
            className="w-full flex gap-2 justify-center items-center py-2 px-5 disabled:bg-blueButton/60 bg-blueButton transition-all duration-300 text-xl hover:scale-105 text-white text-center rounded-xl"
          >
            {loading && (
              <div
                style={{
                  borderColor: `#A9A9A9 transparent #A9A9A9 transparent`,
                }}
                className="border-2 w-4 h-4 aspect-square animate-spin rounded-full"
              ></div>
            )}
            <span>{loading ? 'Logging out...' : 'Log Out'}</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default Settings
